import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { HalfWidthContent } from '../tabs/OverviewTab/OverviewTab.styles';

export const CARD_BORDER_WIDTH = 1;
export const CARD_PADDING = 16;
export const CARD_CONTENT_HEIGHT = 32;
export const CARD_MAX_HEIGHT = CARD_CONTENT_HEIGHT + CARD_PADDING * 2;

export const ExternalLinkBox = styled(HalfWidthContent).attrs({
  backgroundColor: 'background',
  position: 'relative',
  maxHeight: `${CARD_MAX_HEIGHT}px`,
  cursor: 'pointer',
})`
  ${({ isDisabled }) => isDisabled && 'cursor: not-allowed; opacity: 0.4;'}
`;

export const ExternalLinkContent = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  height: `${CARD_CONTENT_HEIGHT}px`,
})``;

export const ExternalLinkTitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'bold',
  lineHeight: 1,
})``;

export const ExternalLinkSubtitle = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
  lineHeight: 1,
})``;

export const ArrowRightBox = styled(Box).attrs({
  borderWidth: `${CARD_BORDER_WIDTH}px`,
  borderStyle: 'solid',
  borderColor: 'heavyLineOutline',
  borderRadius: '5px',
})``;

export const PopoverBox = styled(Box).attrs({
  width: '267px',
  padding: '10px',
  backgroundColor: 'primaryText',
  borderRadius: '5px',
})``;

export const PopoverText = styled(Text).attrs({
  color: 'background',
  size: 'small',
})``;
